import React, { Dispatch } from 'react';
import FormWidget from '../form/FormWidget';
import { FormContainer } from '../form/FormContainer';
import FormItem from '../form/FormItem';
import FormPanel from '../form/FormPanel';
import { FormProvider } from '../form/FormContext';
import Validator from '../form/Validator';
import FormButtons from '../form/FormButtons';
import { LinkState } from '../components/types';
import { FORM_WIDGET_COMPONENTS } from '../form/formConstants';
import I18n, { useI18n } from '../i18n/I18n';
import isEmpty from 'lodash/isEmpty';

type AttachmentsLinkProps = {
    onSave: () => void;
    setLinkState: Dispatch<React.SetStateAction<LinkState>>;
    linkState: LinkState;
    isSavingLinkAttachment: boolean;
    open: boolean;
    onClose?: () => void;
};

export default ({ onSave, open, setLinkState, linkState, isSavingLinkAttachment, onClose }: AttachmentsLinkProps) => {
    const validationRules = {
        linkURL: [Validator.RULES.isRequired, Validator.RULES.url],
        linkName: [
            Validator.RULES.isRequired,
            Validator.Custom((prop, state) => !isEmpty(state.linkName.trim()), useI18n('common.label.required'))
        ]
    };

    if (!open) {
        return null;
    }
    return (
        <FormProvider state={linkState} setState={setLinkState} validationRules={validationRules}>
            <FormPanel>
                <FormContainer>
                    <FormItem>
                        <FormWidget
                            component={FORM_WIDGET_COMPONENTS.sectionTitle}
                            i18nToken={<I18n token="attachment.attach.link" />}
                            containerSx={{ textTransform: 'uppercase' }}
                        />
                    </FormItem>
                    <FormItem>
                        <FormWidget label={<I18n token="common.label.url" />} name="linkURL" />
                    </FormItem>
                    <FormItem>
                        <FormWidget label={<I18n token="common.label" />} name="linkName" />
                    </FormItem>
                    <FormItem>
                        <FormWidget
                            component={FORM_WIDGET_COMPONENTS.metadataAutocomplete}
                            metadataName="DocumentTag"
                            identifier="termset"
                            multiple
                            allowCreate
                            name="tags"
                            label={<I18n token="common.label.tag" />}
                        />
                    </FormItem>
                    <FormItem>
                        <FormButtons onClickCancel={onClose} onClickSave={onSave} isSaving={isSavingLinkAttachment} />
                    </FormItem>
                </FormContainer>
            </FormPanel>
        </FormProvider>
    );
};
